import { IConfig } from "./types";

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string;
const AUTH0_DASHBOARD_CLIENT_ID = import.meta.env.VITE_AUTH0_DASHBOARD_CLIENT_ID as string;
const AUTH0_ORGANIZATION = import.meta.env.VITE_AUTH0_ORGANIZATION as string;
const LANGUAGE = import.meta.env.VITE_LANGUAGE as "en" | "he" | "de";
const ENV = import.meta.env.VITE_ENV as "development" | "staging" | "production";
const API_URL = import.meta.env.VITE_API_URL as string;

export const defaultConfig: IConfig = {
  authDomain: AUTH0_DOMAIN,
  clientId: AUTH0_DASHBOARD_CLIENT_ID,
  organization: AUTH0_ORGANIZATION,
  env: ENV,
  language: LANGUAGE,
  apiUrl: API_URL
}